window.signupPopup = false;

window.addEventListener('shopify:section:select', function(event) {
  const signupPopup = event.target.querySelector('signup-popup');
  if(signupPopup) {
    signupPopup.open();
    window.signupPopup = signupPopup;
  }
});

window.addEventListener('shopify:section:deselect', function(event) {
  if(window.signupPopup) {
    window.signupPopup.close();
    window.signupPopup = false;
  }
});